module.exports = __webpack_public_path__ + "static/media/Cookie.3e53f97d.svg";